import React, { Component } from "react";
import { strings } from "../../../constants/strings";
const BUFER_SCROLL_VALUE = 5

const lang = document.documentElement.lang.slice(0, 2);

export default class TextArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startScroll: () => {
        
      },
      stopScroll: () => {
        
      },
      scrollPosition: 0
    }
  }
  componentDidMount() {
    this.div.addEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate() {
    if (this.props.text !== "" && this.div.scrollHeight > 0) {      
      if (
        this.div.scrollHeight === this.div.clientHeight &&
        !this.props.readingFinished
      ) {
        this.props.readingFinishedAction();
      }
    }
  }

  handleScroll = (e) => {
    if (
      this.div.scrollTop + this.div.clientHeight + BUFER_SCROLL_VALUE >=
      this.div.scrollHeight
    ) {
      this.props.readingFinishedAction();
    }
  };

  render() {    
    return (
      <div className="wpm-text-field">
        <div
          className="section group wpm-field"
          id="text-field"
          ref={(div) => (this.div = div)}
        >
          {
          lang === 'ja'?
            this.props.text.split("--").map((i, key) => {
              return (
                <span className="text-part" key={key}>
                  {i}
                </span>
              );
            })
          :
            this.props.text.split("\n").map((i, key) => {
              return (
                <div key={key}>
                  {i}
                  <br />
                </div>
              );
            })
        }
        </div>
        <div className="wpm-btn">
          <button
            className="btn btn-turquois green"
            disabled={!this.props.readingFinished}
            onClick={this.props.showQuestions}
          >
            {strings.OverlayView_btn_fertig}
          </button>
        </div>
        <div className='web-licence-infotext'>
        {strings.Web_Licence_infotext}
        </div>
      </div>
    );
  }
}
